<mat-card class="tw-h-full tw-rounded-r-none">
    <div class="tw-m-[16px]">
        <div name="threadListHeader" class="tw-flex tw-justify-between">
            <mat-card-title>Thread List</mat-card-title>
            <div id="thread-list-button" class="tw-mr-2">
                <!-- Button Disabled logic explained:
                When the threads are being loaded initially, disable the button
                When a user has a thread made for them, the chat IS NOT NULL AND the threadname IS NULL. They arleady have a chat--Disable the button.
                When an existing thread is being retrieved && the chat is null--Disable the button.
            -->
                <button
                    matTooltip="Create A New Thread"
                    [disabled]="isCreateNewThreadDisabled$ | async"
                    (click)="createNewThread.emit()"
                    mat-mini-fab
                    aria-label="Create New Thread"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <mat-card-subtitle>All your conversations</mat-card-subtitle>

        <mat-selection-list
            #userSelectionList
            hideSingleSelectionIndicator
            multiple="false"
            (selectionChange)="selectThread($event.options[0]?.value)"
        >
            <div
                name="options"
                class="tw-overflow-y-scroll tw-max-h-[500px] tw-bg-[rgba(211,211,211,0.35)]"
            >
                @if (
                    (threadBuffering$ | async) &&
                    currentLoadedThreads.length < 1
                ) {
                    <!--Threads are being loaded initially-->
                    <mat-spinner
                        class="tw-m-auto"
                        [diameter]="60"
                    ></mat-spinner>
                } @else {
                    @for (thread of userThreads$ | async; track $index) {
                        <mat-list-option
                            class="tw-mb-2"
                            [disabled]="
                                (currentChat$ | async)?.threadId ==
                                    thread.threadId ||
                                isThreadBeingDeleted(thread) ||
                                (!(currentChat$ | async) &&
                                    (chatLoading$ | async))
                            "
                            [ngClass]="[
                                (currentChat$ | async)?.threadId ==
                                    thread.threadId ||
                                thread.threadId == selectedThread?.threadId
                                    ? 'tw-bg-[rgba(211,250,211,0.4)]'
                                    : 'tw-bg-[rgba(211,211,211,0.4)]'
                            ]"
                            [value]="thread"
                        >
                            <div
                                class="listOptionContainer"
                                name="listOptionContainer"
                            >
                                <div
                                    class="threadLabelContainer"
                                    name="threadLabelContainer"
                                >
                                    {{
                                        thread?.threadName
                                            ? thread.threadName
                                            : (thread.createDate
                                              | date: "short")
                                    }}
                                </div>
                                <div name="threadDeleteButtonContainer">
                                    <button
                                        mat-icon-button
                                        color="warn"
                                        (click)="
                                            deleteThread(thread);
                                            $event.stopPropagation()
                                        "
                                    >
                                        @if (isThreadBeingDeleted(thread)) {
                                            <!--Thead deletion in process. Keep existing threads and only update when complete instead of blocking UI-->
                                            <mat-spinner
                                                class="tw-m-auto"
                                                [diameter]="20"
                                            ></mat-spinner>
                                        } @else {
                                            <mat-icon>delete</mat-icon>
                                        }
                                    </button>
                                </div>
                            </div>
                        </mat-list-option>
                        <mat-divider></mat-divider>
                    }
                    @if (newThreadIncoming | async) {
                        <mat-list-option
                            class="tw-mb-2 tw-bg-[rgba(211,211,211,0.4)]"
                            [disabled]="true"
                        >
                            <div name="listOptionContainer">
                                <mat-spinner
                                    class="tw-m-auto"
                                    [diameter]="20"
                                ></mat-spinner>
                            </div>
                        </mat-list-option>
                    }
                }
            </div>
        </mat-selection-list>
    </div>
</mat-card>
